import { __assign, __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import { OutlineButton, PrimaryButton, SegmentedButton, TextButton, TonalButton, } from "./styles";
import { generateColorVariants } from "../../utils/functions";
import { Spinner } from "../Spinner";
import { useTheme } from "styled-components";
export var BUTTON_OPTIONS = {
    default: PrimaryButton,
    outlined: OutlineButton,
    tonal: TonalButton,
    text: TextButton,
    segmented: SegmentedButton,
};
export var Button = forwardRef(function Button(_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? "default" : _b, icon = _a.icon, customColor = _a.customColor, color = _a.color, isLoading = _a.isLoading, isSelected = _a.isSelected, children = _a.children, props = __rest(_a, ["variant", "icon", "customColor", "color", "isLoading", "isSelected", "children"]);
    var theme = useTheme();
    var ButtonToRender = BUTTON_OPTIONS[variant];
    var colorVariants = customColor
        ? useMemo(function () { return generateColorVariants(customColor); }, [customColor])
        : color
            ? theme.colors[color]
            : undefined;
    var textAndIcon = !!icon && !!children;
    return (_jsx(ButtonToRender, __assign({ ref: ref, "$hasIcon": !!icon, "$textAndIcon": textAndIcon, isSelected: isSelected, "$colorVariants": colorVariants }, props, { disabled: isLoading || props.disabled, children: isLoading ? (_jsx(Spinner, { color: theme.colors.neutral.light })) : (_jsxs(_Fragment, { children: [icon, children] })) })));
});
//# sourceMappingURL=index.js.map